import { useChangeSearchParams } from '../../../../utils/useChangeSearchParams'
import { searchParamsKeys } from '../../constants'

type UpdateClinicMembersParams = {
  searchText: string
  isNeedToChangeSearchParam?: boolean
  count?: number
}

export const useUpdateClinicMembers = () => {
  const { onChangeSearchParam } = useChangeSearchParams()

  const updateClinicMembers = ({ searchText, isNeedToChangeSearchParam }: UpdateClinicMembersParams) => {
    if (isNeedToChangeSearchParam) {
      onChangeSearchParam({ key: searchParamsKeys.SEARCH_VALUE, value: searchText })
    }
  }

  return { updateClinicMembers }
}
